import React from "react";
import { Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DomainStepView } from "../../../../constants";
import VerifyingInfo from "./VerifyingInfo";

interface IVerifyingInfoViewProps {
  handleSetStep: (value: DomainStepView) => void;
  showCustomSecondStep?: (value: boolean) => void;
  refetchDomainData: () => void;
}

export default function VerifyingInfoView({
  handleSetStep,
  showCustomSecondStep,
  refetchDomainData,
}: IVerifyingInfoViewProps) {
  const { t } = useTranslation();

  const handleContinue = async () => {
    handleSetStep(DomainStepView.Default);
    showCustomSecondStep(false);
    refetchDomainData();
  };

  const handleBack = async () => {
    handleSetStep(DomainStepView.Connect);
  };

  return (
    <div className="mt-4 mt-md-0">
      <VerifyingInfo>
        <div className="mt-4 gy-3 d-flex justify-content-center">
          <Col className="me-3 me-md-4">
            <Button
              variant="outline-dark"
              className="w-100 fw-normal dark-hover"
              onClick={handleBack}
            >
              {t("support.back")}
            </Button>
          </Col>
          <Col>
            <Button
              variant="primary"
              className="w-100 text-white fw-bold order-0 order-lg-1"
              onClick={handleContinue}
            >
              {t("projects.Continue")}
            </Button>
          </Col>
        </div>
      </VerifyingInfo>
    </div>
  );
}
